<template>
  <section
    ref="container"
    class="bg-white px-4 py-6 md:py-9 md:p-8 md:pb-12 mb-8 md:mb-10 rounded-2xl shadow-md relative select-none"
    :class="{
      'pb-16 md:pb-12': $slots.footer,
      'pb-5': !$slots.footer,
    }"
  >
    <div v-if="title || number" class="flex items-baseline mb-5 md:mb-10 gap-2">
      <div
        v-if="number"
        class="size-6 px-[9px] bg-pink-700 rounded-full flex-col justify-center items-center inline-flex text-white text-md font-semibold"
      >
        {{ number }}
      </div>

      <div
        v-if="title"
        class="md:text-lg font-normal"
        :class="{ 'pl-2 md:pl-8': number }"
      >
        {{ title }}
      </div>
    </div>

    <div
      class="flex justify-center flex-wrap md:flex-nowrap gap-6 md:gap-6"
      :role="number ? 'radiogroup' : undefined"
      :name="number"
    >
      <slot />
    </div>

    <div v-if="$slots.footer" class="pr-4">
      <slot name="footer"></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    number: {
      type: String,
    },
    title: {
      type: String,
    },
    autoScroll: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    smoothScrollToTop() {
      this.$refs.container.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
  },

  mounted() {
    if (this.autoScroll) this.smoothScrollToTop();
  },
};
</script>
